import { memo } from 'react';
import { cn } from '../../lib/styles';

interface HeightCollapseProps {
  open: boolean;
  children: React.ReactNode;
}

/**
 * Opens and closes by animating its height (and fading), so the layout never jumps when content appears
 * or goes. Closed content stays mounted but hidden from screen readers and keyboard focus.
 */
const HeightCollapseBase = ({ open, children }: HeightCollapseProps) => {
  return (
    <div
      aria-hidden={!open}
      inert={!open}
      className={cn(
        'grid transition-[grid-template-rows,opacity] duration-300 ease-out motion-reduce:transition-none',
        open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
      )}
    >
      <div className="min-h-0 overflow-hidden">{children}</div>
    </div>
  );
};

export const HeightCollapse = memo(HeightCollapseBase);
